import Box from '@mui/material/Box';
import { FormControl, FormLabel, Skeleton } from '@mui/material';

const CreativeTextsFormSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        maxWidth: '100%',
        alignItems: 'start',
        justifyContent: 'start',
      }}
    >
      <Skeleton
        width={'140px'}
        height={'28px'}
        sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
      />
      <FormControl sx={{ width: '100%', flexDirection: 'row', alignItems: 'start', p: 0 }}>
        <FormLabel
          sx={t => ({
            '&': {
              top: 0,
              flex: '0 0 30%',
              fontSize: t.typography.subtitle2,
              color: t.palette.text.primary,
            },
          })}>
          <Skeleton
            width={'80px'}
            height={'18px'}
            sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
          />
        </FormLabel>
        <Skeleton
          width={'100%'}
          height={'40px'}
          sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
        />
      </FormControl>
      <FormControl sx={{ width: '100%', flexDirection: 'row', alignItems: 'start', p: 0 }}>
        <FormLabel
          sx={t => ({
            '&': {
              top: 0,
              flex: '0 0 30%',
              fontSize: t.typography.subtitle2,
              color: t.palette.text.primary,
            },
          })}>
          <Skeleton
            width={'80px'}
            height={'18px'}
            sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
          />
        </FormLabel>
        <Skeleton
          width={'100%'}
          height={'40px'}
          sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
        />
      </FormControl>
      <FormControl sx={{ width: '100%', flexDirection: 'row', alignItems: 'start', p: 0 }}>
        <FormLabel
          sx={t => ({
            '&': {
              top: 0,
              flex: '0 0 30%',
              fontSize: t.typography.subtitle2,
              color: t.palette.text.primary,
            },
          })}>
          <Skeleton
            width={'80px'}
            height={'18px'}
            sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
          />
        </FormLabel>
        <Skeleton
          width={'100%'}
          height={'200px'}
          sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
        />
      </FormControl>
      <FormControl sx={{ width: '100%', flexDirection: 'row', alignItems: 'start', p: 0 }}>
        <FormLabel
          sx={t => ({
            '&': {
              top: 0,
              flex: '0 0 30%',
              fontSize: t.typography.subtitle2,
              color: t.palette.text.primary,
            },
          })}>
          <Skeleton
            width={'80px'}
            height={'18px'}
            sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
          />
        </FormLabel>
        <Skeleton
          width={'100%'}
          height={'40px'}
          sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
        />
      </FormControl>
      <FormControl sx={{ width: '100%', flexDirection: 'row', alignItems: 'start', p: 0 }}>
        <FormLabel
          sx={t => ({
            '&': {
              top: 0,
              flex: '0 0 30%',
              fontSize: t.typography.subtitle2,
              color: t.palette.text.primary,
            },
          })}>
          <Skeleton
            width={'80px'}
            height={'18px'}
            sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
          />
        </FormLabel>
        <Skeleton
          width={'100%'}
          height={'40px'}
          sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
        />
      </FormControl>
    </Box>
  );
};

export default CreativeTextsFormSkeleton;